import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';

interface CU03603State {
    isVisibleCU03603: boolean;
}

const initialState: CU03603State = {
    isVisibleCU03603: false,
};

export const CU03603Slice = createSlice({
    name: 'CU03603Slice',
    initialState,
    reducers: {
        setVisibleCU03603: (state) => {
            state.isVisibleCU03603 = !state.isVisibleCU03603;
        },
        resetCU03603Slice: () => initialState,
    },
});

export const { setVisibleCU03603 } = CU03603Slice.actions;

export default CU03603Slice.reducer;
